import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileDown, GraduationCap, Building2, ChevronDown } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { btnGhost, btnPrimary } from "@/components/admin/ui";

const KINDS = [["siswa", "SOP Siswa", GraduationCap, "Pendaftaran, login, assessment, rutinitas belajar, kelas daring, offline, bantuan."], ["mitra", "SOP Mitra Lembaga", Building2, "Onboarding, pendaftaran siswa, Portal Mitra, tindak lanjut, laporan, kontrak & keamanan data."]];

async function dl(url, name) {
  try {
    const r = await api.get(url, { responseType: "blob", timeout: 60000 });
    const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(r.data), download: name });
    a.click(); URL.revokeObjectURL(a.href);
  } catch (e) { toast.error(errMsg(e)); }
}

function SopCard({ kind, label, Icon, desc, lang }) {
  const [doc, setDoc] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { setDoc(null); api.get(`/admin/sop/${kind}?lang=${lang}`).then((r) => setDoc(r.data)).catch(() => {}); }, [kind, lang]);
  return (
    <div className="soft-card p-5" data-testid={`sop-card-${kind}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary"><Icon className="h-5 w-5" /></span>
          <div className="min-w-0"><h3 className="font-jpserif text-lg">{label}</h3><p className="text-xs text-muted-foreground">{desc}</p></div>
        </div>
        <div className="flex flex-wrap gap-1.5">
          <button data-testid={`sop-pdf-${kind}-id`} onClick={() => dl(`/admin/sop/${kind}.pdf?lang=id`, `SOP-${kind}-ID.pdf`)} className={btnPrimary.replace("px-5 py-2.5 text-sm", "px-4 py-2 text-xs")}><FileDown className="h-3.5 w-3.5" />PDF Indonesia</button>
          <button data-testid={`sop-pdf-${kind}-jp`} onClick={() => dl(`/admin/sop/${kind}.pdf?lang=jp`, `SOP-${kind}-JP.pdf`)} className={btnGhost}><FileDown className="h-3.5 w-3.5" />PDF 日本語</button>
        </div>
      </div>
      {doc && (
        <div className="mt-4" data-testid={`sop-preview-${kind}`}>
          <p className="text-sm font-semibold">{doc.title}</p>
          <p className="mt-0.5 text-xs text-muted-foreground">{doc.subtitle}</p>
          <ol className="mt-3 divide-y divide-border/60 rounded-xl border border-border">
            {doc.sections.map((s, i) => (
              <li key={s.title}>
                <button data-testid={`sop-section-${kind}-${i}`} onClick={() => setOpen(open === i ? null : i)} className="flex min-h-[44px] w-full items-center justify-between gap-2 px-4 py-2.5 text-left text-sm">
                  <span>{s.title} <span className="text-xs text-muted-foreground">· {s.steps.length} langkah</span></span><ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
                </button>
                {open === i && <ol className="space-y-1.5 px-4 pb-3 text-sm">{s.goal && <li className="text-xs italic text-muted-foreground">{s.goal}</li>}{s.steps.map((x, j) => <li key={j} className="flex gap-2"><span className="shrink-0 font-semibold text-primary">{j + 1}.</span><span>{x}</span></li>)}</ol>}
              </li>
            ))}
          </ol>
          <p className="mt-3 rounded-xl bg-muted/60 px-4 py-3 text-xs">{doc.closing}</p>
        </div>
      )}
    </div>
  );
}

export function SopAdmin() {
  const [lang, setLang] = useState("id");
  return (
    <div className="space-y-5" data-testid="admin-sop">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">Standard Operating Procedure langkah demi langkah. Unduh PDF untuk dibagikan ke siswa atau PIC lembaga; pratinjau di bawah mengikuti bahasa yang dipilih.</p>
        <div className="inline-flex rounded-full border border-border bg-card p-1 text-xs" data-testid="sop-lang">
          {[["id", "Indonesia"], ["jp", "日本語"]].map(([k, l]) => <button key={k} data-testid={`sop-lang-${k}`} onClick={() => setLang(k)} className={`rounded-full px-3 py-1.5 ${lang === k ? "bg-foreground text-background" : "text-muted-foreground"}`}>{l}</button>)}
        </div>
      </div>
      {KINDS.map(([kind, label, Icon, desc]) => <SopCard key={kind} kind={kind} label={label} Icon={Icon} desc={desc} lang={lang} />)}
    </div>
  );
}
